const notificationSound = new Audio('/ringtone.mp3');

export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  const permission = await Notification.requestPermission();
  return permission === 'granted';
};

export const showNotification = async (title: string, options?: NotificationOptions) => {
  const hasPermission = await requestNotificationPermission();
  if (!hasPermission) return;

  try {
    // Play sound
    await notificationSound.play();

    // Show notification
    const notification = new Notification(title, {
      icon: '/logo.png',
      ...options,
    });

    notification.onclick = function () {
      window.focus();
      notification.close();
    };
  } catch (error) {
    console.error('Error showing notification:', error);
  }
};
